














































import { Component, Prop, Vue } from 'vue-property-decorator';
import ThreeDotsMenu from '@/components/icons/ThreeDotsMenu.vue';
import { IDropDownCardMenu } from '@/models/dropdownCardMenu';

@Component({
  components: { ThreeDotsMenu }
})
export default class DropDownCardMenu extends Vue {
  @Prop({}) menus!: Array<IDropDownCardMenu>;
  @Prop({ default: 'contextMenu' }) containerId?: string;
  @Prop({ default: false }) fixedPosition?: boolean;
  @Prop({ default: 'container-scrollable' }) containerScrollClass?: string;

  isOpen = false;
  offset = {
    top: 0,
    left: 0
  };

  get scrollContainer() {
    return document.querySelector(`.${this.containerScrollClass}`);
  }

  mounted() {
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener('scroll', this.scrollEventHandler);
    }
  }

  beforeDestroy() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener(
        'scroll',
        this.scrollEventHandler
      );
    }
  }

  scrollEventHandler() {
    this.isOpen = false;
  }

  handleContextMenuBtnClick() {
    const containerIds = document.querySelectorAll('.dropdown');

    for (const container of containerIds) {
      if (container.id === this.containerId) continue;

      const dropDownEl = document.getElementById(container.id);

      if (dropDownEl) {
        const contentEl = dropDownEl.querySelector(
          '.dropdown__dropdown-content'
        )!;

        contentEl.classList.remove('dropdown__dropdown-content--show');
      }
    }
  }

  onClickDropDownButton() {
    this.isOpen = !this.isOpen;

    const { top, left, width } = this.$el.getBoundingClientRect();

    this.offset = {
      top: top,
      left: left + width
    };

    this.handleContextMenuBtnClick();
  }

  onClickOutside() {
    this.isOpen = false;
  }
}
